import { createCustomEnum } from "../customEnum";

const OverallResidualsStatusTypes = createCustomEnum({
	UploadPending: {
		value: 0,
		name: "upload_pending",
		displayName: "Upload Pending",
	},
	UploadInProgress: {
		value: 1,
		name: "upload_in_progress",
		displayName: "Upload In Progress",
	},
	UploadCompleted: {
		value: 2,
		name: "upload_completed",
		displayName: "Upload Completed",
	},
	ImportInProgress: {
		value: 3,
		name: "import_in_progress",
		displayName: "Import In Progress",
	},
	ImportCompleted: {
		value: 4,
		name: "import_completed",
		displayName: "Import Completed",
	},
	ImportFailed: {
		value: 5,
		name: "import_failed",
		displayName: "Import Failed",
	},
	NormalizationInProgress: {
		value: 6,
		name: "normalization_in_progress",
		displayName: "Normalization In Progress",
	},
	NormalizationCompleted: {
		value: 7,
		name: "normalization_completed",
		displayName: "Data Cleanse In Progress",
	},
	NormalizationFailed: {
		value: 8,
		name: "normalization_failed",
		displayName: "Normalization Failed",
	},
	CalculationInProgress: {
		value: 9,
		name: "calculation_in_progress",
		displayName: "Calculation In Progress",
	},
	CalculationFailed: {
		value: 10,
		name: "calculation_failed",
		displayName: "Calculation Failed",
	},
	CalculationCompleted: {
		value: 11,
		name: "calculation_completed",
		displayName: "Calculations Review In Progress",
	},
	PaymentsInProgress: {
		value: 14,
		name: "payments_in_progress",
		displayName: "Payments In Progress",
	},
	PaymentsCompleted: {
		value: 15,
		name: "payments_completed",
		displayName: "Reporting Pending",
	},
	ReportingInProgress: {
		value: 16,
		name: "reporting_in_progress",
		displayName: "Reporting In Progress",
	},
	ReportingCompleted: {
		value: 17,
		name: "reporting_completed",
		displayName: "Reporting Completed",
	},
});

export default OverallResidualsStatusTypes;

export const FailedOverallResidualsStatuses = [
	OverallResidualsStatusTypes.CalculationFailed,
	OverallResidualsStatusTypes.NormalizationFailed,
	OverallResidualsStatusTypes.ImportFailed,
];
